import Component from '../core/Component'
import Scroll, { getScroll } from '../services/Scroll'
import EventBus from '../core/EventBus'

export const STATES = {
    ACTIVE: 'is-active',
    VISIBLE: 'is-visible',
    BREAKPOINT: 'is-breakpoint',
    NAV_OPEN: 'is-nav-open'
}

export default class FixedHeader extends Component {

    constructor(element) {
        super(element)

        this.ref = {
            buttons: [],
        }
    }

    prepare() {
        Scroll.on("scroll", this.handleScroll)
        this.check()
        EventBus.on('nav-open', this.handleNavOpen)
        EventBus.on('nav-close', this.handleNavClose)
    }

    destroy() {
        Scroll.off("scroll", this.handleScroll)
        EventBus.off('nav-open', this.handleNavOpen)
        EventBus.off('nav-close', this.handleNavClose)
    }

    handleScroll = event => {
        this.check()
    }

    handleNavOpen = () => {
        this.element.classList.add(STATES.NAV_OPEN)
    }

    handleNavClose = () => {
        this.element.classList.remove(STATES.NAV_OPEN)
    }

    check() {
        const pageYOffset = getScroll().y

        const offsetY = pageYOffset || document.documentElement.scrollTop

        if (offsetY > 150) {
            this.element.classList.add(STATES.ACTIVE)
            this.ref.buttons.forEach(item => item.classList.add(STATES.VISIBLE))

        } else {
            this.element.classList.remove(STATES.ACTIVE)
            this.ref.buttons.forEach(item => item.classList.remove(STATES.VISIBLE))
        }
        if (offsetY > 650) {
            this.element.classList.add(STATES.BREAKPOINT)
        } else {
            this.element.classList.remove(STATES.BREAKPOINT)
        }
    }
}
